const forgotPasswordFormatter = (data) => {
    data["domain"] = window.location.origin
    return data
}
export default forgotPasswordFormatter